import { inject, injectable } from 'inversify';
import ApiServiceType, { IApiService } from '../../interfaces/IApiService';
import { FileTypes } from '../../enums';
import { CreateFolderRequest, IFilesApi, UpdateFileRequest } from '../../interfaces/IFilesApi';

@injectable()
export class FilesApi implements IFilesApi {
	constructor(
		@inject(ApiServiceType.IApiService) private apiService: IApiService,
	) {}

	getFilesByCustomer = async (customerId: string) => {
		const url = `api/FilesFolders?customerId=${customerId}`;
		const { data } = await this.apiService.callApi(url, 'GET');
		return data;
	};

  getFilesByDashboard = async(dashboardId: string) => {
    const url = `api/Dashboard/${dashboardId}/File?filterHistory=true`;
    const { data } = await this.apiService.callApi(url, "GET");
    return data;
  }

  getFileByFileId = async (fileId: string) => {
    const url = `/api/FilesFolders/${fileId}`;
    const responseType = "blob";
    const { data } = await this.apiService.callApi(
      url,
      "GET",
      null,
      null,
      responseType
    );
    return data;
  };

  getDashboardFileByFileId = async (dashboardId: string, id: string) => {
    const url = `api/Dashboard/${dashboardId}/File/${id}`;
    const responseType = "blob";
    const { data } = await this.apiService.callApi(
      url,
      "GET",
      null,
      null,
      responseType
    );
    return data;
  };

  postFileToCustomer = async (fileToUpload, customerId: string, folderId: string) => {
    const url = 'api/FilesFolders';
    const formData = new FormData();
    formData.append('File', fileToUpload);
    const createFileRequest = {
      FileTypeId: FileTypes.CustomerFile,
      CustomerId: customerId
    };
    formData.append('FileJsonData', JSON.stringify(createFileRequest));
    if (folderId) {
      formData.append('folderId', folderId)
    }
		const headers = {
			'Content-Type': 'multipart/form-data',
		};
		const { data } = await this.apiService.callApi(
			url,
			'POST',
			formData,
			headers,
		);
		return data;
	};

  postFileToDashboard = async (fileToUpload, dashboardId: string) => {
    const url = `api/Dashboard/${dashboardId}/File`;
    const formData = new FormData();
    formData.append('File', fileToUpload);
    const createFileRequest = {
      FileTypeId: FileTypes.CustomerFile,
      CustomerId: dashboardId,
    };
    formData.append('FileJsonData', JSON.stringify(createFileRequest));

    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const { data } = await this.apiService.callApi(url,
        "POST",
        formData, headers
      );
      return data;
  };

  updateFileName = async(updateFileRequest: UpdateFileRequest) => {
  const url = `/api/FilesFolders/${updateFileRequest.Id}`;
  const {data} =  await this.apiService.callApi(url, 'PUT', updateFileRequest);
  return data;

};

createFolder = async(createFolderRequest: CreateFolderRequest) => {
  const url = `/api/Folder?customerId=${createFolderRequest.customerId}&folderName=${createFolderRequest.folderName}`;
  const {data} =  await this.apiService.callApi(url, 'POST');
  return data;

};

updateFolderName = async(updateFolderRequest: UpdateFileRequest ) => {
  const url = `/api/Folder?folderId=${updateFolderRequest.Id}&newFolderName=${updateFolderRequest.NewName}`;
  const {data} =  await this.apiService.callApi(url, 'PUT');
  return data;
};

deleteFile = async(fileId: string) => {
  const url = `/api/FilesFolders/${fileId}`;
  const {data} = await this.apiService.callApi(url, 'DELETE', null);
  return data;
};

deleteFolder = async(folderId: number) => {
  const url = `/api/Folder?folderId=${folderId}`;
  const {data} = await this.apiService.callApi(url, 'DELETE', null);
  return data;
};

}
